import messages from './cmsBenefit.json' with { type: 'json' };

export const cmsBenefitEn: Readonly<typeof messages> = messages;
